
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { AuthForm } from '../components/AuthForm';
import { Camera } from 'lucide-react';

const Auth = () => {
  const { isAuthenticated, loading, user } = useAuth();
  const navigate = useNavigate();

  // DEBUG: Log changes
  useEffect(() => {
    console.log('Auth page: isAuthenticated=', isAuthenticated, 'loading=', loading, 'user=', user);
  }, [isAuthenticated, loading, user]);

  // If already logged in, redirect to challenge page
  useEffect(() => {
    // Only redirect once finished loading and authenticated
    if (!loading && isAuthenticated) {
      console.log('Redirecting to /challenge');
      navigate('/challenge');
    }
  }, [isAuthenticated, loading, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-[#505081] pt-safe pb-safe">
      <div className="mb-8 text-center">
        <div className="inline-flex items-center justify-center p-2 bg-[#8686AC] rounded-full shadow-sm mb-4">
          <Camera className="h-8 w-8 text-[#272757]" />
        </div>
        <h1 className="text-2xl font-bold mb-2 text-[#272757] font-['Bebas_Neue'] tracking-wider">Foto Fight</h1>
        <p className="text-[#272757]/80">Daily photo battles with friends</p>
      </div>

      <div className="w-full max-w-sm bg-[#272757] p-6 rounded-lg shadow-sm border-2 border-[#8686AC]">
        <AuthForm />
      </div>

      <p className="mt-8 text-sm text-[#272757]/80 text-center max-w-sm">
        By signing up, you agree to our Terms of Service and Privacy Policy.
      </p>
    </div>
  );
};

export default Auth;
